import { Styled } from '../../types';

/**
 * Prefixes all keys of an object with a `$`
 *
 * @param obj The object whose keys are to be prefixed.
 * @param prefix The prefix to add to each key.
 * @returns An object with prefixed keys.
 */
function prefixKeysStyled<T extends Record<string, unknown>>(
  obj: T,
): Styled<T> {
  const prefixedObj = {} as Record<string, unknown>;

  for (const key in obj) {
    prefixedObj[`$${key}`] = obj[key];
  }

  return prefixedObj as Styled<T>;
}

export default prefixKeysStyled;
